import { Card, DetailsCategoryItem, HospitalLineIcon, InformationLineIcon, RoundElement } from 'ui';

type P = {
  medicalGroupName: string;
};

const EventDetailsCard = ({ medicalGroupName }: P) => (
  <Card title={<Card.Title icon={<InformationLineIcon />}>Details</Card.Title>}>
    <DetailsCategoryItem
      category="Medical group"
      icon={
        <RoundElement color="default" size="extra-small">
          <HospitalLineIcon type="dark-default" />
        </RoundElement>
      }
      name={medicalGroupName}
    />
  </Card>
);

export default EventDetailsCard;
